import React from 'react';
import { string, node } from 'prop-types';

const Page = ({ children, title }) => (
  <div className="ErrorPage">
    <div className="ErrorPage-container">
      <h1 className="ErrorPage-title" data-testid="ErrorPage-title">
        {title}
      </h1>
      <div className="ErrorPage-content" data-testid="ErrorPage-content">
        {children}
      </div>
    </div>
  </div>
);

Page.propTypes = {
  children: node.isRequired,
  title: string
};

Page.defaultProps = {
  title: "We're sorry… this page does not exist"
};

export default Page;

require('/var/lib/jenkins/workspace/auto-borrower-apply-ui_Release_0/src/pages/404/404.scss');